import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {clearTokens, isTokenValid} from "../../api/authApi";
import {alertAfterFunction} from "../../utils/alert";
import {getAuthInfo} from "../../utils/authUtils";

const AuthContext = createContext<any>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const authInfo = getAuthInfo();
    if(authInfo) {
      if(!isTokenValid()) {
        alertAfterFunction(
            "세션이 만료되었습니다. 다시 로그인해주세요.",
            () => {
              clearTokens();
              navigate('/login', {replace: true});
            }
        );
      } else {
        // 토큰 유효기간 연장
        const expiresIn = localStorage.getItem("expiresIn");
        const expireTime = Date.now() + 1000 * 60 * Number(expiresIn);
        localStorage.setItem("tokenExpire", String(expireTime));
      }
    }
  }, [navigate]);
  return <AuthContext.Provider value={{ user, setUser }}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => useContext(AuthContext);
